<div class="coordinate-answer">
  <app-icon [size]="'24'" [glyph]="'geolocation'"></app-icon>
</div>
